export default __webpack_public_path__ + "static/media/nsjtj.d8148fca.png";